import * as trace from 'owa-trace';
import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import findConversationWithStartIndex from 'owa-mail-store/lib/services/findConversationWithStartIndex';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getViewFilterForTable from 'mini-mail-list-store/lib/utils/getViewFilterForTable';
import MailFolderTableQuery from 'mini-mail-list-store/lib/store/schema/MailFolderTableQuery';
import onInitialTableLoadComplete from './onInitialTableLoadComplete';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { getRowSortByProperty } from '../../utils/tables/getRowSortByProperty';
import { INITIAL_LOAD_ROW_COUNT } from './TableLoadingConstants';
import { onLoadInitialRowsSucceeded } from './onLoadInitialRowsSucceeded';

export const loadInitialConversationFromServer = action('loadInitialConversationFromServer')(
    function loadInitialConversationFromServer(
        mailTableQuery: MailFolderTableQuery,
        tableView: TableView,
        shouldPrefetchFirstNRows: boolean
    ): Promise<void> {
        return findConversationWithStartIndex({
            baseFolderId: mailTableQuery.baseFolderId,
            startIndex: 0,
            rowsToLoad: INITIAL_LOAD_ROW_COUNT,
            viewFilter: getViewFilterForTable(tableView),
            sortResults: getRowSortByProperty(mailTableQuery),
            focusedViewFilter: getFocusedFilterForTable(tableView),
            findConversationShapeName: mailTableQuery.requestShapeName,
            shouldTryToUseSessionDataResponse: mailTableQuery.shouldTryToUseSessionDataResponse,
        })
            .then((responseMessage: FindConversationResponseMessage) => {
                const isSuccessResponseClass = responseMessage.ResponseClass === 'Success';
                if (isSuccessResponseClass) {
                    onLoadInitialRowsSucceeded(tableView, responseMessage);
                } else {
                    const { MessageText, ResponseCode } = responseMessage;
                    const error = new Error(MessageText) as trace.TraceErrorObject;
                    error.fetchErrorType = 'ServerFailure';
                    error.responseCode = ResponseCode;
                    throw error;
                }

                onInitialTableLoadComplete(
                    tableView,
                    isSuccessResponseClass,
                    shouldPrefetchFirstNRows
                );
            })
            .catch(error => {
                onInitialTableLoadComplete(
                    tableView,
                    false /* isSuccessResponseClass */,
                    shouldPrefetchFirstNRows
                );

                trace.errorThatWillCauseAlert(
                    `loadInitialConversationFromServer failing : Response code - ${error.responseCode}`,
                    error
                );
            });
    }
);
